import React from "react";

export default function LeaderBoardResult({ user }) {
  return (
    <tr className="border-b border-slate-600/50">
      <td className="table-td text-center">{user?.position}</td>
      <td className="table-td text-center">{user?.name}</td>
      <td className="table-td text-center">{user?.quizMark}</td>
      <td className="table-td text-center">{user?.assignmentMark}</td>
      <td className="table-td text-center">{user?.totalMark}</td>
    </tr>
  );
}
